module.exports = __webpack_public_path__ + "static/moshi-28b87dd7cd4f0711cad5b9df161d9940.png";